module.exports = __webpack_public_path__ + "static/fonts/iconosVidaSoftware.4b12752.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconosVidaSoftware-v1.0/fonts/iconosVidaSoftware.woff
// module id = /UK/
// module chunks = 3